import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute,
} from '@angular/core';
import { CountBadges } from '../count-badges';
import { MibBadgeDirective, MibIconComponent } from '@medinbox/angular';

@Component({
  selector: 'mai-smartphone-button',
  imports: [CountBadges, MibBadgeDirective, MibIconComponent],
  templateUrl: './smartphone-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartphoneButton {
  readonly active = input(false, { transform: booleanAttribute });
  readonly piiDetected = input(false, { transform: booleanAttribute });
  // Make sure those counts are always number, 0 by default (even if we passe something else than a number)
  readonly successCount = input(0, { transform: (value) => numberAttribute(value, 0) });
  readonly warningCount = input(0, { transform: (value) => numberAttribute(value, 0) });

  readonly displayCount = computed(() => this.successCount() > 0 || this.warningCount() > 0);
}
